import Vue from 'vue';
import VueGtag from 'vue-gtag';
import VueSession from 'vue-session';

import './plugins/vuetify';
import App from './App.vue';
import router from './router';
import store from './stores/store';

/* Import babel-polyfill for IE11 + Safari 9 support */
import 'babel-polyfill';

if (process.env.NODE_ENV === 'production') {
  console.log = () => {};
  console.debug = () => {};
}

Vue.config.productionTip = false;

Vue.use(VueSession, { persist: true });

Vue.use(VueGtag, {
  config: {
    id: 'G-P8CS3Z55QR',
    params: {
      send_page_view: true,
    },
  },
});

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
